import { FormattedMessage } from "react-intl";

const AtlassianIntelligence = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.aiPowered.content.body.v2"
                    defaultMessage="Get more done with AI-powered summaries, generative AI editing, and natural language to build automations or search issues."
                />
            </p>
        </div>
    );
};

export default AtlassianIntelligence;
